





































import { Component } from 'vue-property-decorator';
import { Components } from '@baklavajs/plugin-renderer-vue';

@Component
export default class ContextMenu extends Components.ContextMenu {
  private static ADD_NODE = 'Add Node';

  // eslint-disable-next-line no-underscore-dangle
  get _items() {
    return this.items.filter((item) => item.label !== ContextMenu.ADD_NODE)
      .map((i) => ({ ...i, hover: false }));
  }
}
